import AUStates from './es-ES/AU-states.json.js';
import CAStates from './es-ES/CA-states.json.js';
import CNStates from './es-ES/CN-states.json.js';
import CompanySize from './es-ES/company-size.json.js';
import CompanyType from './es-ES/company-type.json.js';
import countries from './es-ES/countries.json.js';
import DEStates from './es-ES/DE-states.json.js';
import HKStates from './es-ES/HK-states.json.js';
import INStates from './es-ES/IN-states.json.js';
import industry from './es-ES/industry.json.js';
import interests from './es-ES/interests.json.js';
import jobRole from './es-ES/job-role.json.js';
import levelOfAWSUsage from './es-ES/level-of-aws-usage.json.js';
import projectTimeline from './es-ES/project-timeline.json.js';
import PTStates from './es-ES/PT-states.json.js';
import USStates from './es-ES/US-states.json.js';
import useCase from './es-ES/use-case.json.js';
import languagePreference from './es-ES/language-preference.json.js';
import Navatar from '../es-ES/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
